import React, { useRef, useEffect } from 'react'
import useScript from 'react-script-hook'
import cls from 'classnames'
import styles from './index.module.less'
const APP_CODE = 'amljpt'

interface ICaptchaProps {
  visible: boolean
  /** 多语言配置 */
  lang: string
  /** 验证成功回调 */
  onSuccess: FnType
  /** 验证取消回调 */
  onCancel?: FnType
  /** html 中容器元素的 ID，需保证存在 */
  id?: string
  className?: string
  /** 验证码类型，如 'authn' */
  captchaType?: string
  /** 业务参数 */
  bizParam?: Record<string, any>
  /** 校验场景 */
  captchaScene: string
  appCode?: string
}
const CDN_OPTIONS = {
  src: `https://r2cdn.myshopline.com/static/rs/acuf/prod/latest/bundle.iife.js`,
  checkForExisting: true,
}

// 校验分为滑块校验和身份校验
const Captcha: React.FC<ICaptchaProps> = (props) => {
  const { visible, lang, onSuccess, onCancel, id = 'captcha-default-id', className, captchaType, bizParam, captchaScene, appCode = APP_CODE } = props
  const captchaInstants = useRef<IArmorCaptcha>(null)
  const [loading] = useScript(CDN_OPTIONS)
  const onSuccessRef = useRef(null)
  const onCancelRef = useRef(null)
  onSuccessRef.current = (token) => {
    onSuccess(token, captchaType)
  }
  onCancelRef.current = onCancel

  // 初始化验证
  useEffect(() => {
    if (loading || !visible) return
    const config: any = {
      wrapId: id,
      origin: process.env.CAPTCHA_URL,
      appCode,
      captchaScene,
      onSuccess: onSuccessRef.current,
      onClose: onCancelRef.current,
    }
    if (captchaType) {
      config.captchaType = captchaType
    }
    if (bizParam) {
      config.bizParam = bizParam
    }
    captchaInstants.current = new ArmorCaptcha(config)
    captchaInstants.current.changeLanguage(lang)
    return () => captchaInstants.current.destroy()
  }, [id, loading, visible, lang, captchaType, bizParam, captchaScene, appCode])

  // 切换语言
  useEffect(() => {
    if (visible) {
      captchaInstants.current && captchaInstants.current.changeLanguage(lang)
    }
  }, [lang, visible])

  return (
    <>
      {visible && (
        <div className={styles.captcha}>
          <div id={id} className={cls(styles.content, className)}></div>
        </div>
      )}
    </>
  )
}

Captcha.displayName = 'Captcha'
export default Captcha
